import {
	type FetchExternalAddressesParamsNetworks,
	RecipientTypes,
	type WalletExternalAddress
} from '@capsicum/common';
import { useCallback } from 'react';

import { useWalletExternalAddressesQuery } from '../data-access/queries';
import { type ReceiveNetworks, type WalletRecipientItem } from '../models';

type NetworkParams = FetchExternalAddressesParamsNetworks;

/**
 * @param network - 'ethereum' | 'cc1' | 'cc2'
 * @returns list of recipients per network
 */
export const useWalletWithdrawRecipients = (network: NetworkParams) =>
	useWalletExternalAddressesQuery(
		network,
		useCallback((data: Array<WalletExternalAddress> | undefined): Array<WalletRecipientItem> | undefined => {
			if (!data?.length) {
				return undefined;
			}

			return data.reduce<Array<WalletRecipientItem>>((acc, recipient) => {
				if ((recipient.type as RecipientTypes) !== RecipientTypes.NCW) {
					acc.push({
						blockchainAddress: recipient.blockchainAddress || '',
						exchange: recipient.externalOwnerInfo?.walletOrExchangeName || '',
						id: recipient.id || '',
						label: recipient.label || '',
						networkType: (recipient.network?.type as ReceiveNetworks) || '',
						type: (recipient.type as RecipientTypes) || ''
					});
				}

				return acc;
			}, []);
		}, [])
	);
